import SendMailModel from "@/layout/model/SendMailModel";

export class SendMailKit extends SendMailModel {
    codeCommande = ''
}